import {
  Code,
  Heading,
  Link,
  OrderedList,
  Text,
  UnorderedList,
} from '@chakra-ui/layout';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const MarkdownRenderer = ({ content }: { content: string | null }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node: _node, ...props }) => {
          const href = props.href || '';
          if (href.startsWith('http://') || href.startsWith('https://')) {
            return (
              <Link
                color="green.600"
                rel="noopener noreferrer"
                target="_blank"
                {...props}
              />
            );
          }
          return props.children;
        },
        h1: ({ node: _node, ...props }) => (
          <Heading
            as="h1"
            size="2xl"
            fontWeight="bold"
            marginY="4"
            {...props}
          />
        ),
        h2: ({ node: _node, ...props }) => (
          <Heading as="h2" size="xl" fontWeight="600" marginY="3" {...props} />
        ),
        h3: ({ node: _node, ...props }) => (
          <Heading as="h3" size="lg" fontWeight="600" marginY="3" {...props} />
        ),
        h4: ({ node: _node, ...props }) => (
          <Heading as="h4" size="md" fontWeight="600" marginY="3" {...props} />
        ),
        h5: ({ node: _node, ...props }) => (
          <Heading as="h5" size="sm" fontWeight="600" marginY="5" {...props} />
        ),
        p: ({ node: _node, ...props }) => (
          <Text fontSize="md" marginTop="0" marginBottom="3" {...props} />
        ),
        ul: ({ node: _node, ...props }) => (
          <UnorderedList
            marginBottom="3"
            paddingLeft="2"
            spacing="1"
            sx={{
              'li::marker': { color: 'var(--chakra-colors-green-500)' },
              li: { paddingInlineStart: '0.25rem' },
            }}
            {...props}
          />
        ),
        ol: ({ node: _node, ...props }) => (
          <OrderedList marginBottom="3" {...props} />
        ),
        strong: ({ node: _node, ...props }) => (
          <Text as="strong" fontWeight="bold" {...props} />
        ),
        code: ({ node, ...props }) => {
          const isInline =
            node?.position?.start?.line === node?.position?.end?.line;
          return (
            <Code
              colorScheme="gray"
              overflowX="auto"
              {...(!isInline && { padding: 4 })}
              {...(isInline && { transform: 'translateY(6px)' })}
              {...props}
            />
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};
